




import Vue from "vue";
import Component from "vue-class-component";
import FormSwitch from "@/components/form/FormSwitch.vue";

@Component({
  props: {
    data: {
      required: true
    }
  },
  components: {
    FormSwitch
  }
})
export default class SwitchCellType extends Vue {}
